import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../../lib/cn";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        "h-11 w-full rounded-md border border-border bg-surface px-3 text-[16px] text-text",
        "placeholder:text-text-muted",
        "focus:outline-none focus:ring-2 focus:ring-[var(--focus-ring)] focus:border-primary",
        "disabled:bg-surface-2 disabled:cursor-not-allowed",
        className,
      )}
      {...rest}
    />
  );
});
